<template>
  <div :class="$vuetify.breakpoint.mdAndUp?'pt-8 pb-8 pr-8 pl-8':'pt-3 pb-3 pr-2 pl-2'">
    <v-card class="mx-auto" max-width="800">
      <v-img :src="headerImageSrc" aspect-ratio="2"></v-img>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          class="mr-3"
          @click="switchFav"
          :small="$vuetify.breakpoint.xsOnly"
          :color="faved?'red':'gray'"
          :dark="faved"
        >
          <span v-if="!faved">{{ $t("addFav") }}</span>
          <span v-else>{{ $t("remFav") }}</span>
          <v-icon>mdi-heart</v-icon>
        </v-btn>
      </v-card-actions>
      <v-card-title class="pb-4 pl-4 display-1">{{ title }}</v-card-title>
      <v-card-actions>
        <v-list-item>
          <v-list-item-avatar>
            <v-img :src="avatarImgSrc"></v-img>
          </v-list-item-avatar>
          <v-list-item-content>
            <v-list-item-title>{{ $t("author") }}: {{authorName}}</v-list-item-title>
            <v-list-item-subtitle>{{date}}</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </v-card-actions>
      <v-card-actions>
        <v-spacer></v-spacer>
        <span>Share with:</span>
        <ShareNetwork
          class="px-2"
          :url="baseUrl + $route.path"
          network="facebook"
          :quote="title"
          :hashtags="styles.join(',')"
        >
          <v-icon large color="#3B5998">mdi-facebook</v-icon>
        </ShareNetwork>
        <ShareNetwork
          class="px-2"
          :url="baseUrl + $route.path"
          network="twitter"
          :title="title"
          :hashtags="styles.join(',')"
          :twitter-user="twitterUser.substr(1)"
        >
          <v-icon large color="#1DA1F2">mdi-twitter</v-icon>
        </ShareNetwork>
      </v-card-actions>
      <v-card-text class="py-1">
        <span>{{ $t("style") }}:</span>
        <v-chip
          v-for="style in styles"
          :key="style"
          class="ma-1"
          color="styleTag"
          label
          small
        >{{style}}</v-chip>
      </v-card-text>
      <v-card-text class="px-8 article-body" v-html="document"></v-card-text>
      <v-card-text class="py-1">
        <span>{{ $t("genre") }}:</span>
        <v-chip
          v-for="genre in genres"
          :key="genre"
          class="ma-1"
          color="amber accent-2"
          label
          small
        >{{genre}}</v-chip>
      </v-card-text>
      <v-card-text class="py-1">
        <span>{{ $t("tag") }}:</span>
        <v-chip
          v-for="tag in tags"
          :key="tag"
          class="ma-1"
          color="brown lighten-3"
          label
          small
        >{{tag}}</v-chip>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { EventBus } from "@/event.js";

import { BLOCKS } from "@contentful/rich-text-types";
import { documentToHtmlString } from "@contentful/rich-text-html-renderer";

const dateFormat = require("dateformat");
const contentful = require("contentful");
const client = contentful.createClient({
  space: process.env.VUE_APP_CONTENTFUL_SPACE_ID,
  accessToken: process.env.VUE_APP_CONTENTFUL_ACCESS_TOKEN
});
const baseUrl = process.env.VUE_APP_BASE_URL;
const twitterUser = process.env.VUE_APP_TWITTER_USER;

export default {
  data() {
    return {
      title: "",
      headerImageSrc: "",
      avatarImgSrc: "",
      document: "",
      authorName: "",
      date: "",
      styles: [],
      genres: [],
      tags: [],
      baseUrl,
      twitterUser
    };
  },
  metaInfo: {
    meta: [
      {
        property: "og:type",
        content: "article",
        vmid: "og:type"
      }
    ]
  },
  methods: {
    switchFav() {
      const article = {
        id: this.$route.params.articleId,
        title: this.title,
        imgUrl: this.headerImageSrc,
        date: this.date
      };
      if (this.faved) {
        this.$store.commit("DeleteFavedArticle", article);
      } else {
        this.$store.commit("AddFavedArticle", article);
      }
    },
    toHtmlString(obj) {
      const options = {
        renderNode: {
          [BLOCKS.EMBEDDED_ASSET]: ({
            data: {
              target: { fields }
            }
          }) =>
            `<img style="display: block; margin: auto;" src="https:${fields.file.url}?w=600" width='80%'/>`
        }
      };
      return documentToHtmlString(obj, options);
    }
  },
  created() {
    // change i18n locale from path params
    const locale = this.$route.params.locale;
    document.documentElement.lang = locale;
    this.$root.$i18n.locale = locale;
    EventBus.$emit("loading", true);
    const that = this;
    const entryId = this.$route.params.articleId;
    client
      .getEntries({
        content_type: "article",
        "sys.id": entryId,
        locale: locale
      })
      .then(entries => {
        const item = entries.items[0];
        that.title = item.fields.title;
        that.headerImageSrc =
          item.fields.headerImage.fields.file.url + "?w=800";
        that.document = that.toHtmlString(item.fields.body);
        that.avatarImgSrc = item.fields.author.fields.image.fields.file.url;
        that.authorName = item.fields.author.fields.name;
        that.date = dateFormat(Date.parse(item.sys.createdAt), "yyyy/m/d ddd");
        that.styles = item.fields.styles
          ? item.fields.styles.map(style => {
              return style.fields.displayName;
            })
          : [];
        that.genres = item.fields.genres
          ? item.fields.genres.map(genre => {
              return genre.fields.displayName;
            })
          : [];
        that.tags = item.fields.tags
          ? item.fields.tags.map(tag => {
              return tag.fields.displayName;
            })
          : [];
        document.title = `Foodealist|多様な食を発信するフードスタイルメディア「フーディアリスト」 - ${item.fields.title}`;
        EventBus.$emit("loading", false);
      })
      .catch(err => {
        console.log(err);
        EventBus.$emit("loading", false);
      });
  },
  computed: {
    ...mapState(["favedArticles"]),
    faved: function() {
      return this.$route.params.articleId in this.favedArticles;
    }
  }
};
</script>

<i18n>
{
  "en": {
    "author": "Author",
    "style": "Style",
    "genre": "Genres",
    "tag": "Tag",
    "addFav":"Add to Favourites",
    "remFav":"Remove from Favorites"
  },
  "ja": {
    "author": "投稿者",
    "style": "食のスタイル",
    "genre": "ジャンル",
    "tag": "タグ",
    "addFav":"お気に入りに追加",
    "remFav":"お気に入りを解除"
  }
}
</i18n>

<style scoped>
.title-on-image {
  color: white;
  text-shadow: 0px 0px 15px #000, 0px 0px 5px #000;
}
</style>
